import { ColorModeScript } from '@chakra-ui/react';
import React from 'react';
import * as ReactDOM from 'react-dom/client';
import Main from './Main';
import './Stylesheets/main.css'
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from "./authConfig";
import { HelmetProvider } from 'react-helmet-async';

/* Author/Creator - Blake Brazier */
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
const msalInstance = new PublicClientApplication(msalConfig);

root.render(
    <>
      <HelmetProvider>
        <ColorModeScript />
        <Main pca={msalInstance}/>
      </HelmetProvider>
    </>
);
